﻿namespace PortalLibs.Shared

open System
open System.Text.RegularExpressions

[<AutoOpen>]
module Formatting =
    
  type FormatCurrencyRounding =
    | Under1
    | AllTwoDigits
    | AllZero

  type FormatCurrencyNegativeValues =
    | MinusSign
    | Parenthesis

  let formatNumber withPlus negativeValues asCurrency rounding (value: float) =
    let digits =
      match rounding with
      | AllZero -> 0
      | AllTwoDigits -> 2
      | Under1 ->
        if Math.Abs(value) <= 0.1 then 2
        else if Math.Abs(value) <= 1.0 then 1
        else 0

    let rounded = Math.Round(value, digits)

    (if rounded > 0.0 && withPlus then
       "+"
     else
       "")
    + (if rounded < 0.0 then
         (match negativeValues with
          | MinusSign -> "-"
          | Parenthesis -> "(")
       else
         "")
    + (if asCurrency then "$" else "")
    + Regex.Replace(
      (sprintf
        (match digits with
         | 2 -> "%.2f"
         | 1 -> "%.2f"
         | _ -> "%.0f")
        (Math.Abs(rounded))),
      "\d(?=(\d\d\d)+(?!\d))",
      "$&,"
    )
    + (if rounded < 0.0 && negativeValues = Parenthesis then
         ")"
       else
         "")

  let formatPercent negativeValues percent =

    (if percent < 0.0 then
       (match negativeValues with
        | MinusSign -> "-"
        | Parenthesis -> "(")
     else
       "")
    + sprintf "%s%%" (Math.Round(percent * 100.0, 1).ToString("0.0#"))
    + (if percent < 0.0 && negativeValues = Parenthesis then
         ")"
       else
         "")